import React, { FunctionComponent } from 'react'

import { IProps } from './IProps'
import { StyledBetaSpan } from './style'

export const BetaSpan: FunctionComponent<IProps> = ({ style }) => {
    return <StyledBetaSpan style={style}>Beta</StyledBetaSpan>
}
